// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { ChevronsDown } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconChevronsDown(props: any) {
    return <IconBase icon={ChevronsDown} {...props} />
  }

  export default IconChevronsDown
  